/**
 * 말풍선 컴포넌트
 *
 * 봇 메시지(좌측, 흰색) / 사용자 메시지(우측, 브랜드 컬러)를 표시.
 *
 * 디자인 토큰: docs/02-design-system.md
 */

import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Logo } from './Logo';

interface BubbleProps {
  role: 'bot' | 'user';
  children: ReactNode;
  timestamp?: string;
  className?: string;
}

export function Bubble({ role, children, timestamp, className }: BubbleProps) {
  const isBot = role === 'bot';

  return (
    <div
      className={cn(
        'ml-flex ml-gap-2 ml-animate-fade-in',
        isBot ? 'ml-justify-start' : 'ml-justify-end',
        className
      )}
    >
      {isBot && <BubbleAvatar />}
      <div className={isBot ? 'ml-max-w-[78%]' : 'ml-max-w-[78%]'}>
        <div
          className={cn(
            'ml-px-3 ml-py-2.5',
            'ml-text-cb-base ml-leading-snug',
            'ml-whitespace-pre-wrap ml-break-words',
            isBot
              ? 'ml-bg-white ml-border ml-border-line ml-rounded-cb-md ml-rounded-bl-[4px] ml-shadow-cb-bubble ml-text-ink'
              : 'ml-bg-brand-600 ml-text-white ml-rounded-cb-md ml-rounded-br-[4px]'
          )}
        >
          {children}
        </div>
        {timestamp !== undefined && (
          <div
            className={cn(
              'ml-mt-1 ml-text-cb-xs ml-text-mute',
              isBot ? 'ml-text-left ml-pl-1' : 'ml-text-right ml-pr-1'
            )}
          >
            {timestamp}
          </div>
        )}
      </div>
    </div>
  );
}

function BubbleAvatar() {
  return <Logo size="sm" />;
}
